import { Injectable } from '@angular/core';
import { ElementApiService } from 'dbweb-core';
import { map } from 'rxjs/operators';
import { Category } from './types/category';
import { IElementHis, ILabel, ILabelHisItem, ILabelHisKey, ILabelKey, OwnerByEnum, INode } from './types/model';
import { of } from 'rxjs';
export interface ModelElementCategory {
	ID: string;
	EleName: string;
	OwnerBy: OwnerByEnum;
	Owner: string;
	Name: string;
	Position: number;
	Labels: ModelElementLabel[];
}

export interface ModelElementLabel {
	CategoryID: string;
	ID: string;
	Name: string;
	Position: number;
	LastWriteTime: Date;
	LastWriteUser: string;
	Conts: string;
	PlainText: string;
}
export interface AddCategoryParam {
	EleName: string;
	Name: string;
	OwnerBy: string;
	BeforeAtID?: string;
}

export interface SetCategoryPositionParam {
	ID: string;
	Position: number;
}
export interface SetCategoryPositionResult {
	ID: string;
	Position: number;
}
export interface UpdateCategoryParam {
	ID: string;
	Name: string;
	OwnerBy: string;
}
export interface AddLabelParam {
	CategoryID: string;
	Name: string;
	Conts: string;
	PlainText: string;
}
export interface SetLabelPositionParam {
	CategoryID: string;
	ID: string;
	Position: number;
}
export interface SetLabelPositionResult {
	ID: string;
	Position: number;
}
export interface UpdateLabelParam {
	CategoryID: string;
	ID: string;
	Name: string;
	Conts: string;
	PlainText: string;
}
export interface IFetchElementAllCategoriesResult {
	OwnerBy: string;
	Owner: string;
	DeptName: string;
}
export class FetchElementAllCategoriesResult implements IFetchElementAllCategoriesResult {
	OwnerBy: string;
	Owner: string;
	DeptName: string;
	public static fromInterface(data: IFetchElementAllCategoriesResult) {
		const rev = new FetchElementAllCategoriesResult();
		Object.assign(rev, { ...data });
		return rev;
	}
	categoryDisplayLabel() {
		switch (this.OwnerBy) {
			case OwnerByEnum.ownerByEle:
				return 'ç¼ºç';
			case OwnerByEnum.ownerByDept:
				return `${this.Owner}.${this.DeptName}`;
			case OwnerByEnum.ownerByUser:
				return 'ç§æ';
		}
	}
}
export interface FetchLabelResult {
	Name: string;
	Position: number;
	LastWriteTime: Date;
	LastWriteUser: string;
	Conts: string;
	PlainText: string;
}
@Injectable({
	providedIn: 'root'
})
export class EleViewBackFaceService {
	readonly ele = 'eleview';
	constructor(private api: ElementApiService) {}
	addCategory(param: AddCategoryParam) {
		return this.api
			.post<Category>(this.ele, 'add-category', param)
			.pipe(map(v => (v ? Category.fromInterface(v) : null)));
	}
	removeCategory(id: string) {
		return this.api.post<boolean>(this.ele, 'remove-category', id);
	}
	setCategoryPosition(param: SetCategoryPositionParam) {
		return this.api.post<SetCategoryPositionResult[]>(this.ele, 'set-category-position', param);
	}
	updateCategory(param: UpdateCategoryParam) {
		return this.api.post<boolean>(this.ele, 'update-category', param);
	}
	fetchCategories(param: { EleName: string; OwnerBy: OwnerByEnum; Owner: string }) {
		return this.api
			.get<Category[]>(this.ele, 'fetch-categories', param)
			.pipe(map(v => (v ? v.map(vv => Category.fromInterface(vv)) : null)));
	}
	fetchElementAllCategories(eleName: string) {
		return this.api.get<IFetchElementAllCategoriesResult[]>(this.ele, 'fetch-element-all-categories', eleName).pipe(
			map(v => {
				return v.map(vv => FetchElementAllCategoriesResult.fromInterface(vv));
			})
		);
	}
	// è·åèåé¡¹æææ ç­¾çæ¥å¿
	fetchCategoryLabelHis(param: { EleName: string; OwnerBy: OwnerByEnum; Owner: string[] }) {
		return this.api.get<IElementHis[]>(this.ele, 'fetch-category-label-his', param);
	}
	// è·åæ ç­¾çæ¥å¿åè¡¨
	fetchLabelHisList(param: ILabelKey) {
		return this.api.get<ILabelHisItem[]>(this.ele, 'fetch-label-his-list', param);
	}
	// æ ¹æ®æ¶é´è·ålabelçåå®¹
	fetchLabelHis(param: ILabelHisKey) {
		return this.api.get<{
			Conts: string;
			PlainText: string;
		}>(this.ele, 'fetch-label-his', param);
	}
	addLabel(param: AddLabelParam) {
		return this.api.post<ILabel>(this.ele, 'add-label', param);
	}
	removeLabel(param: ILabelKey) {
		return this.api.post<boolean>(this.ele, 'remove-label', param);
	}
	nodeToString(param: INode) {
		if (param) {
			return this.api.post<string>(this.ele, 'node-to-string', param);
		} else {
			return of('');
		}
	}
	stringToNode(param: string) {
		if (param) {
			return this.api.post<INode>(this.ele, 'string-to-node', param);
		} else {
			return of(null);
		}
	}
	setLabelPosition(param: SetLabelPositionParam) {
		return this.api.post<SetLabelPositionResult[]>(this.ele, 'set-label-position', param);
	}
	updateLabel(param: UpdateLabelParam) {
		return this.api.post<ILabel>(this.ele, 'update-label', param);
	}
	fetchLabel(param: ILabelKey) {
		return this.api.get<FetchLabelResult>(this.ele, 'fetch-label', param);
	}
	fetchFullCategories(param: { EleName: string; OwnerBy: OwnerByEnum; Owner: string }) {
		return this.api.get<ModelElementCategory[]>(this.ele, 'fetch-full-categories', param);
	}
}
